import { render, staticRenderFns } from "./MemberFooter.vue?vue&type=template&id=40da281d&scoped=true&"
import script from "./MemberFooter.vue?vue&type=script&lang=js&"
export * from "./MemberFooter.vue?vue&type=script&lang=js&"
import style0 from "./MemberFooter.vue?vue&type=style&index=0&id=40da281d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da281d",
  null
  
)

export default component.exports